import { NgModule } from '@angular/core';
import { FormbirdServicesModule } from 'formbird-services';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { MatAutocompleteModule} from '@angular/material/autocomplete';
import {GeoAutoCompleteModule} from './geo-auto-complete/geo-auto-complete.module';

@NgModule({
  declarations: [],
  imports: [BrowserModule, MatIconModule, FormbirdServicesModule, MatAutocompleteModule, GeoAutoCompleteModule],
  exports: [],
  providers: [],
})
export class FormbirdMappingModule {}
